var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningToast({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "color",
    d: "M19.7558 5.61326L14.3858 0.244128C14.2296 0.0878727 14.0176 0 13.7967 0H6.20335C5.98237 0 5.77045 0.0878727 5.61419 0.244128L0.244235 5.61326C0.0878729 5.76951 0 5.98143 0 6.20241V13.7974C0 14.0183 0.0878729 14.2303 0.244235 14.3865L5.61419 19.7559C5.77045 19.9122 5.98236 20.0001 6.20335 20.0001H13.7967C14.0176 20.0001 14.2296 19.9122 14.3858 19.7559L19.7558 14.3865C19.9121 14.2303 20 14.0184 20 13.7974V6.20241C20 5.98144 19.9121 5.76951 19.7558 5.61326ZM11.3707 4.16657L10.8332 11.6667H9.16657L8.6599 4.16657H11.3707ZM9.99983 16.6667C9.07942 16.6667 8.33316 15.9205 8.33316 15C8.33316 14.0795 9.07942 13.3334 9.99983 13.3334C10.9204 13.3334 11.6665 14.0795 11.6665 15C11.6665 15.9205 10.9204 16.6667 9.99983 16.6667Z",
    fill: "#621389"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningToast);
export default __webpack_public_path__ + "static/media/WarningToast.494e0199457b409689d1d58590cedc26.svg";
export { ForwardRef as ReactComponent };